module.exports = __webpack_public_path__ + "static/media/girl-icon.b0792cbb.png";